import React from "react";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import { formatDecimal } from "../../../util/decimalFormatter";

const AccountSummary = () => {
  const account = useSelector((state) => state.account);
  const { t } = useTranslation();
  return (
    <table className="table">
      <thead>
        <tr>
          <th>{t("Title")}</th>
          <th>{t("Balance")}</th>
          <th>{t("Open PL")}</th>
          <th>{t("Equity")}</th>
        </tr>
      </thead>
      <tbody>
        <tr>
          <td>{t("User Balance")}</td>
          <td>{formatDecimal(account?.balance?.toFixed(2), 2)}</td>
          <td>{formatDecimal(account?.openPnl?.toFixed(2), 2)}</td>
          <td> {formatDecimal(parseFloat(account?.equity).toFixed(2), 2)}</td>
        </tr>
      </tbody>
    </table>
  );
};

export default AccountSummary;
